import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CategorieResultPage } from './categorie-result';
import { ComponentsModule } from '../../components/components.module';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    CategorieResultPage,
  ],
  imports: [
    ComponentsModule,
		PipesModule,
    IonicPageModule.forChild(CategorieResultPage),
  ],
})
export class CategorieResultPageModule {}



// WEBPACK FOOTER //
// ./src/pages/categorie-result/categorie-result.module.ts